/** E14.1 Filialen: alle Läden der Inhaberin auf einen Blick, Wechsel und Mieter aus einer Filiale übernehmen. */
import { useState } from "react";
import { Button, EmptyState, Notice, Seitenzustand } from "../ui";
import { Card, KpiTile, PageHeader } from "../ui/Layout";
import { formatEuro } from "@shared/geld";
import { useFilialMieter, useFilialMieterUebernehmen, useFilialen, useLadenWechseln } from "./wachstum-api";

export function Filialen() {
  const filialen = useFilialen();
  const wechseln = useLadenWechseln();
  const [mieterOffen, setMieterOffen] = useState(false);
  const kandidaten = useFilialMieter(mieterOffen);
  const uebernehmen = useFilialMieterUebernehmen();
  const [hinweis, setHinweis] = useState<string | null>(null);
  return (
    <>
      <PageHeader kicker="Filialen" title="Alle Läden" sub="Läden, in denen du Inhaberin oder Inhaber bist; Mieter lassen sich aus einer Filiale übernehmen" actions={<Button variant="secondary" icon="users" onClick={() => setMieterOffen((o) => !o)}>Mieter aus Filiale übernehmen</Button>} />
      {hinweis ? <Notice tone="success">{hinweis}</Notice> : null}
      <Seitenzustand query={filialen} istLeer={(d) => d.laeden.length < 2} leer={<EmptyState illustration="empty-shelf" title="Nur ein Laden">Sobald du in einem zweiten Laden Inhaberin oder Inhaber bist, erscheinen hier beide nebeneinander. Weitere Läden legt der Anbieter an oder du registrierst sie mit derselben E-Mail.</EmptyState>}>
        {(d) => (
          <div className="sc-col" style={{ gap: "var(--space-4)" }}>
            {d.laeden.map((l) => (
              <Card key={l.id} title={l.aktuell ? `${l.name} (dieser Laden)` : l.name} actions={!l.aktuell ? <Button variant="quiet" icon="chevron-right" onClick={() => wechseln.mutate(l.id)} loading={wechseln.isPending && wechseln.variables === l.id}>Zu diesem Laden</Button> : undefined}>
                <div className="sc-kpis">
                  <KpiTile label="Regale" value={l.regale} note={`${l.frei} frei${l.baldFrei ? `, ${l.baldFrei} bald frei` : ""}`} />
                  <KpiTile label="Aktive Mieter" value={l.mieter} />
                  <KpiTile label="Verkäufe heute" value={l.verkaeufeHeute} note={formatEuro(l.umsatzHeuteCent)} />
                  <KpiTile label="Offene Aufgaben" value={l.offeneAufgaben} />
                </div>
              </Card>
            ))}
          </div>
        )}
      </Seitenzustand>
      {mieterOffen ? (
        <Card title="Mieter aus einer Filiale übernehmen">
          <p className="sc-muted">Übernommen werden Name, Kontakt, Adresse und Bankverbindung. Die Person meldet sich im Portal wie gewohnt an und sieht beide Läden. Verträge und Artikel bleiben je Laden getrennt.</p>
          <Seitenzustand query={kandidaten} istLeer={(k) => k.kandidaten.length === 0} leer={<p className="sc-muted">Keine weiteren Mieter in anderen Filialen, die hier noch fehlen.</p>}>
            {(k) => (
              <table className="rg-table">
                <thead><tr><th>Name</th><th>E-Mail</th><th>Filiale</th><th><span className="rg-sr">Aktion</span></th></tr></thead>
                <tbody>
                  {k.kandidaten.map((m) => (
                    <tr key={m.mieterId}>
                      <td>{m.name}</td>
                      <td>{m.email}</td>
                      <td>{m.quelleLaden} · {m.mieternummer}</td>
                      <td><Button variant="quiet" icon="plus" loading={uebernehmen.isPending && uebernehmen.variables?.mieterId === m.mieterId} onClick={() => uebernehmen.mutate({ quelleLadenId: m.quelleLadenId, mieterId: m.mieterId }, { onSuccess: (r) => setHinweis(`${m.name} übernommen, Mieternummer ${r.mieternummer}.`) })}>Übernehmen</Button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Seitenzustand>
          {uebernehmen.isError ? <Notice tone="error">{uebernehmen.error.message}</Notice> : null}
        </Card>
      ) : null}
    </>
  );
}
